import React from 'react';
import { BackButton } from './BackButton';

interface PageHeaderProps {
  /** Заголовок страницы */
  title: string;
  /** Показывать кнопку назад */
  showBackButton?: boolean;
  /** Кастомный обработчик для кнопки назад */
  onBackClick?: () => void;
  /** Дополнительный контент справа от заголовка (например, кнопка "Редактировать") */
  rightAction?: React.ReactNode;
  /** Подзаголовок (опционально) */
  subtitle?: string;
  /** Дополнительные CSS классы для заголовка */
  className?: string;
}

/**
 * PageHeader - компонент заголовка страницы с кнопкой "назад"
 * Обеспечивает единообразный дизайн заголовков во всём приложении
 */
export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  showBackButton = true,
  onBackClick,
  rightAction,
  subtitle,
  className = '',
}) => {
  return (
    <div className="space-y-1">
      {/* Header line with back button and optional right action */}
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2 flex-1">
          {showBackButton && <BackButton onClick={onBackClick} />}
          <h1
            className={`text-2xl font-bold ${className}`}
            style={{ color: 'var(--text-primary)' }}
          >
            {title}
          </h1>
        </div>
        {rightAction && <div className="flex-shrink-0">{rightAction}</div>}
      </div>

      {/* Optional subtitle */}
      {subtitle && (
        <p className="text-sm" style={{ color: 'var(--text-hint)' }}>
          {subtitle}
        </p>
      )}
    </div>
  );
};
